import { signalStore, withState, withComputed, patchState, withMethods } from '@ngrx/signals';
import { computed } from '@angular/core';
import { EnteAutocompleteItem } from 'cdc-conte-ui-kit';
import { RicercaRichiesteNuovoInvioParams } from '../models/interfaces/documenti-adempimenti/filtri-ricerca-richieste-nuovo-invio.interface';

const filtriCompleti = {} as RicercaRichiesteNuovoInvioParams;

/** Valori di default di pagina/dimensione pagina, usati quando non è presente nessuna ricerca salvata. */
const DEFAULT_PAGE = 0;
const DEFAULT_SIZE = 10;

export const FiltriRichiesteNuovoInvioStore = signalStore(
  { providedIn: 'root' },

  withState({
    filtriCompleti: filtriCompleti,
    page: DEFAULT_PAGE,
    size: DEFAULT_SIZE,
    loaded: false,
    error: null as string | null,
    // `filtriCompleti.sequEnte` conserva solo l'id dell'ente (necessario per la query verso il BE).
    // Questo campo conserva invece l'intero oggetto selezionato nell'autocomplete (con la relativa
    // descrizione), così da poter ripristinare visivamente il valore del campo 'Denominazione ente'.
    denominazioneEnteSelezionata: null as EnteAutocompleteItem | null,
  }),

  withComputed(({ filtriCompleti }) => ({
    filtriSalvati: computed(() => filtriCompleti()),
  })),
  withMethods((store) => {
    return {
      saveFiltriRicerca(filtriCompleti: RicercaRichiesteNuovoInvioParams) {
        patchState(store, {
          filtriCompleti: filtriCompleti,
          loaded: true,
          error: null as string | null
        });
      },
      /**
       * Persiste la pagina e la dimensione pagina correnti della lista documenti, in modo da poter
       * ripristinare la stessa vista quando si ritorna da 'indietro' nella pagina di dettaglio documento.
       */
      savePagina(page: number, size: number) {
        patchState(store, { page, size });
      },
      /** Persiste l'oggetto ente selezionato nell'autocomplete 'Denominazione ente', per il ripristino visivo del campo. */
      saveDenominazioneEnteSelezionata(denominazioneEnteSelezionata: EnteAutocompleteItem | null) {
        patchState(store, { denominazioneEnteSelezionata });
      },
      hasAtLeastOneValue(): boolean {
        const filtriCompleti = store.filtriCompleti();
        // sequStato === null indica che l'utente ha rimosso esplicitamente il filtro 'Stato Richiesta'
        // (il default del form non è mai null): va trattato come un filtro attivo, anche se tutti gli
        // altri campi sono vuoti, altrimenti lo stato salvato andrebbe perso al ripristino.
        if (filtriCompleti.sequStato === null) {
          return true;
        }
        return Object.values(filtriCompleti).some((value) => {
          if (value === null || value === undefined) return false;
          if (typeof value === 'string') return value.trim().length > 0;
          if (Array.isArray(value)) return value.length > 0;
          if (value instanceof Date) return !isNaN(value.getTime());
          if (typeof value === 'number') return !isNaN(value);
          return true;
        });
      },
      resetState(){
          patchState(store, {
          filtriCompleti: {} as RicercaRichiesteNuovoInvioParams,
          page: DEFAULT_PAGE,
          size: DEFAULT_SIZE,
          loaded: false,
          error: null as string | null,
          denominazioneEnteSelezionata: null,
        });
      }
    };
  }),
);
